<template>
  <div class="ws-experts">
    <header class="ws-experts__header">
      <ws-experts-filter @change="onFilter" :filter.sync="filter" />
    </header>
    <section class="ws-experts__content">
      <ws-list-view class="ws-experts__list is-table is-small"
                    :class="{ 'is-pending':isPending, 'is-loading':isFindPending }"
                    :data="list"
                    :header="true"
                    :item-field-id-key="'uniq_guid_key'"
                    :skeleton="isPending"
                    :columns="columns"
                    :detailed="true">
        <template slot-scope="props" class="ws-experts__item">
          <ws-list-view-item-column>
            <figure class="image is-48x48">
              <ws-avatar v-if="props.row.user_info" :id="props.row.user_info.guid"
                         :name="`${ props.row.user_info.first.display } ${props.row.user_info.last.display}`"
                         sizeType="Small"
                         :size="48" />
            </figure>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <!--<a :href="getProfileLink(props.row.user_info.guid)" class="has-text-weight-bold has-text-primary" v-if="props.row.user_info">
              {{ props.row.user_info.last.display  }} {{ props.row.user_info.first.display  }} {{ props.row.user_info.middle.display  }}
            </a>-->
            <span class="has-text-weight-bold has-text-primary" v-if="props.row.user_info">
              {{ props.row.user_info.last.display  }} {{ props.row.user_info.first.display  }} {{ props.row.user_info.middle.display  }}
            </span>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <span v-if="props.row.user_info">{{ props.row.user_info.email }}</span>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <span v-if="props.row.user_info">{{ props.row.user_info.profile.contacts.communication.phone.map(p => p.value).join(',') }}</span>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <span>{{ props.row.region.title.display }}</span>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <span><b>{{ props.row.competency.code }}</b> {{ props.row.competency.name.display }}</span>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <div>
              <div v-html="props.row.certificates && props.row.certificates.map(certificate => `Сертификат №${certificate.number} от ${moment(certificate.created_at).format('DD.MM.YYYY')}` ).join('<br>')"></div>
              <div v-html="props.row.attestations && props.row.attestations.map(attestation => `Свидетельство №${attestation.number} от ${moment(attestation.created_at).format('DD.MM.YYYY')}` ).join('<br>')"></div>
            </div>
          </ws-list-view-item-column>
        </template>
        <template slot-scope="props" slot="details">
          <ws-experts-list-details :exams="(props.row.exams || []).map((exam) => { return { guid: exam.exam_guid, role: exam.role }} )" />
        </template>
        <template slot="skeleton">
          <ws-list-view-skeleton-item :height="'41px'" :boxCount="1" :boxHeights="['42px']" />
          <ws-list-view-skeleton-item :height="'71px'" :boxCount="5" :boxHeights="['25px', '25px', '25px', '25px', '25px']" />
          <ws-list-view-skeleton-item :height="'71px'" :boxCount="5" :boxHeights="['25px', '25px', '25px', '25px', '25px']" />
          <ws-list-view-skeleton-item :height="'71px'" :boxCount="5" :boxHeights="['25px', '25px', '25px', '25px', '25px']" />
        </template>
      </ws-list-view>
    </section>
    <footer class="ws-experts__footer">
      <ws-pagination
        @change="onPageChange"
        :align="'right'"
        :totalItems="pagination.total"
        :itemsPerPage="pagination.per_page"
        :disabled="isPending"
        :currentIndex="pagination.current_page - 1">
      </ws-pagination>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import listMixin from '@/mixins/list.mixin'
import WsExpertsFilter from '@/components/de/experts/WsExpertsFilter'
import WsExpertsListDetails from '@/components/de/experts/WsExpertsListDetails'

export default {
  name: 'WsExpertsList',
  components: {
    WsExpertsListDetails,
    WsExpertsFilter
  },
  mixins: [listMixin],
  data () {
    return {
      ready: 0,
      moment,
      columns: [
        {
          label: ' '
        },
        {
          label: 'ФИО'
        },
        {
          label: 'Email'
        },
        {
          label: 'Телефон'
        },
        {
          label: 'Регион'
        },
        {
          label: 'Профессия/специальность (ДЭ)'
        },
        {
          label: 'Номер свидетельства/сертификата'
        }
      ]
    }
  },
  watch: {
    ready (value) {
      if (value > 0) {
        this._fetch()
      }
    }
  },
  computed: {
    ...mapState('refbook/experts-list', {
      isFindPending: 'isFindPending',
      pagination: 'pagination'
    }),
    ...mapGetters('refbook/experts-list', ['list'])
  },
  methods: {
    ...mapActions('refbook/experts-list', ['find', 'remove']),
    ...mapMutations('refbook/experts-list', ['clearAll']),
    getProfileLink (guid) {
      return `${__config.services.profile}/user/${guid}`
    },
    async _fetch () {
      this.clearAll()
      try {
        await this.find({
          query: {
            k: this.keyword,
            page: this.page,
            per_page: this.per_page,
            ...this.filter,
            with_light_certificates: true,
            roles: ['main', 'lineal']
          },
          options: {
            arrayFormat: 'bracket',
            isUniqKey: true
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  },
  created () {
    const unwatchFilter = this.$watch('filter', function () {
      this.ready++
      unwatchFilter()
    })
  }
}
</script>

<style lang="scss">
  .ws-experts {
    &__search {
      margin-bottom: 2rem;
    }

    &__list {
      position: relative;
      margin-bottom: 25px;
      min-height: 400px;

      &.is-table {
        .ws-list-view__header,
        .ws-list-view__content {
          display: grid;
          grid-template-columns: 75px minmax(200px, 1fr) minmax(200px, 1fr) minmax(100px, 1fr) minmax(150px, 1fr) minmax(150px, 1fr)  minmax(200px, 1fr);
          grid-column-gap: 1px;
        }
        .ws-list-view__item-column {
          padding: 5px 10px;
          word-wrap: break-word;
        }
      }
    }

    &__details {
      padding-top: 1rem;
      border-top: 1px solid #ccc;

      &-list {
        &.is-table {
          .ws-list-view__header,
          .ws-list-view__content {
            display: grid;
            grid-template-columns: 200px repeat(3, 1fr);
            grid-column-gap: 1px;
          }
        }
      }
    }
  }
</style>
